export default {
    METHODS_TITLE: "Методы",
    METHODS_NAME: "Метод",
    METHODS_ID: "ID метода",
    METHODS_GROUP: "Иерархия метода",
    OBJECT: "Объект",
    OBJECT_ATTRIBUTE: "Необходимые атрибуты",
    FILTER_PLACEHOLDER: "Поиск"
};
